import JSON5 from "json5";

/**
 * Transport capabilities the VS Code extension host advertises via a
 * `<script id="inspect-host-capabilities">` JSON block injected into the
 * webview HTML. Absence of the marker means a legacy host (named-RPC only).
 */
export function readHostCapabilities(
  doc: Pick<Document, "getElementById"> = document
): string[] {
  const el = doc.getElementById("inspect-host-capabilities");
  const text = el?.textContent;
  if (!text) {
    return [];
  }
  try {
    const parsed: unknown = JSON5.parse(text);
    return Array.isArray(parsed)
      ? parsed.filter((x): x is string => typeof x === "string")
      : [];
  } catch {
    return [];
  }
}
